import classNames from 'classnames';
import { forwardRef } from 'react';
import { LinkProps, useLinkClickHandler } from 'react-router-dom';

import Button, { ButtonProps } from './Button';

// Local Typings
export interface ButtonLinkProps extends Omit<ButtonProps, 'as' | 'role'> {
  to?: LinkProps['to'];
}

// Component Definition
const ButtonLink = forwardRef<HTMLButtonElement, ButtonLinkProps>(({
  href,
  onClick,
  target,
  to,
  ...props
},
buttonRef) => {
  const handleClick = useLinkClickHandler<HTMLButtonElement>(to ?? '');

  if (to) {
    return (
      <Button
        {...props}
        as="a"
        className={classNames(props.className, 'button-link')}
        onClick={event => {
          onClick?.(event);
          if (!event.defaultPrevented) {
            handleClick(event);
          }
        }}
        ref={buttonRef}
        tabIndex={0}
      />
    );
  }

  return (
    <Button
      {...props}
      as="a"
      className={classNames(props.className, 'button-link')}
      href={href}
      onClick={onClick}
      ref={buttonRef}
      role="link"
      tabIndex={0}
      target={target}
    />
  );
});

export default ButtonLink;
